import { createContext } from 'react';

export const BingMapsContext = createContext({});
